import { render, staticRenderFns } from "./DietList.vue?vue&type=template&id=41dbf5e3&scoped=true&"
import script from "./DietList.vue?vue&type=script&lang=js&"
export * from "./DietList.vue?vue&type=script&lang=js&"
import style0 from "./DietList.vue?vue&type=style&index=0&id=41dbf5e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dbf5e3",
  null
  
)

export default component.exports